import { useQueryClient } from '@tanstack/react-query';

import type { SetPremiumItemArgs } from '../../api/types/premiumContent.types';

import { setPremiumItem } from '../../api/premiumContent.api';
import { queryKeys } from '../../queryKeys';
import { useMutation } from '../base';

export function useSetPremiumItem() {
  const queryClient = useQueryClient();
  const response = useMutation({
    mutationFn: (args: SetPremiumItemArgs) => setPremiumItem(args),
    onSuccess: () => {
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.premiumContent.fetchInfiniteCatalog._def,
      });
    },
  });
  return {
    ...response,
    isLoading: response.status === 'pending',
  };
}
